import React from 'react';
import { Form, Row } from 'react-bootstrap';
import LimitationSetting from './LimitationSetting/LimitationSetting';
import styles from './editLimitation.module.scss';
import { ChangeOperateAlertDialog } from 'components/CampaignLimitation/ChangeOperateAlertDialog/ChangeOperateAlertDialog';
import i18n from 'i18n';
import _ from 'lodash';
import Tags from 'components/common/Tags/Tags';
import { DefaultKeywordComponentModel } from 'components/CampaignLimitation/KeywordComponent/KeywordComponentModel';
import { AudienceInfo } from 'components/AudienceInfo/AudienceInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { EditLimitationModel } from './EditLimitationModel';
import { Order } from 'core/order/Order';
import { LIMITATION_TYPE } from './LimitationSetting/limitationConfig/limitationSettingsType';
import { unicornkeywordName } from './LimitationSetting/limitationConfig/defaultLimitationInventorySettings';
import { Modal } from 'components/common/Modal/Modal';
import {
  CHANNEL_GROUP_ID,
  ChannelGroupSetting
} from 'core/channelGroup/ChannelGroupSettings';
import { SwitchField } from 'components/common/form/field/SwitchField';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import {
  addOnDisabled,
  addOnEnabled,
  inCondition
} from 'core/permission/PermissionDSL';
import { LimitationData } from 'core/limitation/Limitation';

export class EditLimitation extends React.Component<
  {
    model: EditLimitationModel;
    limitationType?: LIMITATION_TYPE;
    renderGeneralFields?: any;
    order?: Order;
    renderFixOutdoorLimitationSection?: () => React.ReactNode;
    renderWeatherSection?: () => React.ReactNode;
    renderMapSection?: (
      handleChange: (
        operate: string,
        type: string,
        value: SelectOptions[]
      ) => void
    ) => React.ReactNode;
    renderGeocoderBinder?: () => React.ReactNode;
    onChange?: (limitationValue: LimitationData) => void;
  },
  any
> {
  keywordModel: any;
  handler?: number;
  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
      type: '',
      newOperate: '',
      orgOperate: '',
      limitationValue: {
        INST: true
      }
    };
    this.keywordModel = new DefaultKeywordComponentModel('name', '', () => {
      // This is intentional
    });
  }

  componentDidMount() {
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
    this.props.model.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.model !== this.props.model) {
      this.handler && prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
      this.props.model.init();
    }
  }

  componentWillUnmount() {
    this.handler && this.props.model.event.remove(this.handler);
  }

  hideModal = () => {
    this.setState({
      modalShown: false
    });
  };

  changeOperate = (
    orgOperate = this.state.orgOperate,
    type = this.state.type,
    newOperate = this.state.newOperate
  ) => {
    const limitationValue = this.props.model.limitationValue;
    if (!limitationValue[newOperate]) {
      limitationValue[newOperate] = [];
    }
    let limitationdelete = limitationValue[orgOperate].findIndex(
      function (element) {
        return element.type === type;
      }
    );
    let IsInNewLimitationOperateGroup = limitationValue[newOperate].findIndex(
      function (element) {
        return element.type === type;
      }
    );
    if (IsInNewLimitationOperateGroup > -1) {
      limitationValue[newOperate].splice(IsInNewLimitationOperateGroup, 1);
    }
    limitationValue[newOperate].push(
      limitationValue[orgOperate][limitationdelete]
    );
    limitationValue[orgOperate].splice(limitationdelete, 1);
    this.hideModal();
    this.props.onChange?.(limitationValue);
    this.props.model.onLimitationChange();
  };

  handleChangeOpUnicornkeyword = (orgOperate, type, newOperate) => {
    if (!unicornkeywordName.includes(type)) {
      return;
    }
    const limitationValue = this.props.model.limitationValue;
    const lastUnicornkeywordTypes = _.without(unicornkeywordName, type);
    lastUnicornkeywordTypes.forEach((lastUnicornkeywordType) => {
      const unicornKeyword = _.findIndex(limitationValue[orgOperate], [
        'type',
        lastUnicornkeywordType
      ]);
      const newOperateUnicornKeyword = _.findIndex(
        limitationValue[newOperate],
        ['type', lastUnicornkeywordType]
      );
      if (unicornKeyword === -1 && newOperateUnicornKeyword !== -1) {
        limitationValue[newOperate].splice(newOperateUnicornKeyword, 1);
      } else if (unicornKeyword !== -1) {
        this.changeOperate(orgOperate, lastUnicornkeywordType, newOperate);
      }
    });
  };

  handleChangeSetting = (inventory, operate) => {
    this.props.model.showInventory(inventory, operate);
  };

  handleUnicornkeywordLanguage = (operate, type) => {
    if (!unicornkeywordName.includes(type)) {
      return;
    }
    const { limitationValue } = this.props.model;
    const keywordAllNoValue = unicornkeywordName
      .filter((s) => s !== 'unicornlanguage')
      .every((keywordName) => {
        const keywordValue = _.find(limitationValue[operate], [
          'type',
          keywordName
        ]);
        return _.isNil(keywordValue) || keywordValue.length === 0;
      });

    if (keywordAllNoValue) {
      const lastUnicornkeywordTypes = _.without(unicornkeywordName, type);

      lastUnicornkeywordTypes.forEach((unicornkeywordType) => {
        const unicornKeywordDelete = _.findIndex(limitationValue[operate], [
          'type',
          unicornkeywordType
        ]);
        if (unicornKeywordDelete !== -1) {
          limitationValue[operate].splice(unicornKeywordDelete, 1);
        }
      });
    }
  };

  handleDeleteLimitation = (operate, type) => {
    let limitationValue = this.props.model.limitationValue;
    let limitationdelete = limitationValue[operate].findIndex(
      function (element) {
        return element.type === type;
      }
    );
    if (limitationdelete !== -1) {
      limitationValue[operate].splice(limitationdelete, 1);
    }
    this.handleUnicornkeywordLanguage(operate, type);
    this.props.onChange?.(limitationValue);
    this.props.model.onLimitationChange();
  };

  handleChangeOperate = (orgOperate, type, newOperate) => {
    const IsInNewLimitationOperateGroup = this.props.model.limitationValue[
      newOperate
    ]
      ? this.props.model.limitationValue[newOperate].findIndex(
          function (element) {
            return element.type === type;
          }
        )
      : -1;
    if (IsInNewLimitationOperateGroup > -1) {
      this.setState({
        modalShown: true,
        orgOperate: orgOperate,
        type: type,
        newOperate: newOperate
      });
    } else {
      this.handleChangeOpUnicornkeyword(orgOperate, type, newOperate);
      this.changeOperate(orgOperate, type, newOperate);
    }
  };

  changeUnicornkeywordOperate = (
    orgOperate = this.state.orgOperate,
    newOperate = this.state.newOperate
  ) => {
    const type = 'unicornlanguage';
    this.handleChangeOpUnicornkeyword(orgOperate, type, newOperate);
    this.changeOperate(orgOperate, type, newOperate);
  };

  handleChange = (operate, type, value) => {
    if (
      (Array.isArray(value) && value.length > 0) ||
      (!Array.isArray(value) && value !== undefined)
    ) {
      let limitationValue = this.props.model.limitationValue;
      if (!limitationValue[operate]) {
        limitationValue[operate] = [];
      }
      const indexOFLimitationChange = limitationValue[operate].findIndex(
        function (element) {
          return element.type === type;
        }
      );
      if (indexOFLimitationChange > -1) {
        limitationValue[operate][indexOFLimitationChange].value = value;
      } else {
        limitationValue[operate].push({ value: value, type: type });
      }
      this.props.onChange?.(limitationValue);
      this.props.model.onLimitationChange();
    } else {
      this.handleDeleteLimitation(operate, type);
    }
  };

  handleTestModeChange = (event) => {
    const checked = event.target.checked;
    const newValue = checked ? 1 : 0;
    let limitationValue = this.props.model.limitationValue;
    let indexOFLimitationChange = limitationValue['other'].findIndex(
      (element) => element.type === 'testMode'
    );
    if (indexOFLimitationChange > -1) {
      limitationValue['other'][indexOFLimitationChange].value = newValue;
    } else {
      limitationValue['other'].push({
        op: 'inc',
        value: newValue,
        type: 'testMode'
      });
    }
    this.props.onChange?.(limitationValue);
    this.handleChangeDealId(checked ? ['demo_space'] : []);
  };

  handleChangeDealId = (values) => {
    const lastValue = _.last(values);
    if (typeof lastValue === 'string') {
      values[values.length - 1] = { label: lastValue, value: lastValue };
    }

    values = values.map((value) => ({
      label: _.trim(value.label),
      value: _.trim(value.value)
    }));
    let limitationValue = this.props.model.limitationValue;
    let indexOFLimitationChange = limitationValue['other'].findIndex(
      (element) => element.type === 'dealId'
    );
    if (indexOFLimitationChange > -1) {
      limitationValue['other'][indexOFLimitationChange].value = values;
    } else {
      limitationValue['other'].push({
        op: 'inc',
        value: values,
        type: 'dealId'
      });
    }
    this.forceUpdate();
  };

  renderLimitationPage = () => {
    const { show, inventory, fetchingEstimateData } = this.props.model.state;
    const { limitationValue, addonFeature, limitationSetting, taOptionsCache } =
      this.props.model;
    const { type, newOperate } = this.state;
    const channel = _.get(this.props.model.channelData, 'channel');
    // Campaign limitation add-ons are scoped per channel group. The flat key is
    // `campaign_channel_${channelGroupId}_${featureKey}` where channelGroupId is
    // the numeric ChannelGroupSetting id (e.g. RTB = 0), matching how the agency
    // add-on form and limitation inventory settings build these keys.
    const channelLimitationScope = `campaign_channel_${
      channel
        ? ChannelGroupSetting.fromKey(channel).config.id
        : CHANNEL_GROUP_ID.RTB
    }`;
    const enablePMPDealKey = `${channelLimitationScope}_enablePMPDeal`;
    const testModeKey = `${channelLimitationScope}_testMode`;
    const handleChangeOperateForAlert = unicornkeywordName.includes(type)
      ? this.changeUnicornkeywordOperate
      : this.changeOperate;

    const defaultDealId: any = { value: [], type: 'dealId' };
    let dealId = defaultDealId;
    let testMode;
    if (limitationValue['other']) {
      const dealIdValue = limitationValue['other'].find(function (element) {
        return element.type === 'dealId';
      });
      dealId = dealIdValue ? dealIdValue : defaultDealId;
      testMode = limitationValue['other'].find(function (element) {
        return element.type === 'testMode';
      });
    }
    const renderLimitationSetting = (operationSet) => {
      return (
        <LimitationSetting
          taOptionsCache={taOptionsCache}
          limitationSetting={limitationSetting}
          permission={addonFeature}
          showInventory={show === operationSet}
          value={limitationValue[operationSet]}
          onChange={this.handleChange.bind(this, operationSet)}
          onChangeInventory={this.handleChangeSetting}
          operate={operationSet}
          inventorySelected={inventory}
          onDeleteLimitation={this.handleDeleteLimitation}
          onChangeOperate={this.handleChangeOperate}
          errors={_.get(this.state.errors, operationSet)}
          channel={channel}
        />
      );
    };
    const estimateData = this.props.model.estimateData;
    const limitationType = this.props.limitationType
      ? this.props.limitationType
      : LIMITATION_TYPE.CAMPAIGN;
    const needManualGetAudienceEstimatedData =
      limitationType === LIMITATION_TYPE.CAMPAIGN &&
      channel === ChannelGroupSetting.RTB.key;

    return (
      <div>
        {this.props.renderGeocoderBinder && this.props.renderGeocoderBinder()}
        {this.props.model.supportAudienceEstimation &&
          limitationType === LIMITATION_TYPE.CAMPAIGN && (
            <>
              <fieldset className={styles.editLimitaionContainer}>
                <legend>
                  <span>{i18n.t('limitation.labels.audienceDefinition')}</span>
                </legend>
              </fieldset>
              <div className={styles.borderTop} />
              <div className={styles.audienceDefinition}>
                <AudienceInfo
                  loading={fetchingEstimateData}
                  lowerBound={estimateData.lowerBound}
                  upperBound={estimateData.upperBound}
                  threshold={_.get(
                    this.props.model.channelData,
                    'audienceLowestThreshold',
                    0
                  )}
                  estimateReady={estimateData.estimateReady}
                  warning={estimateData.warning}
                  refreshData={
                    needManualGetAudienceEstimatedData
                      ? this.props.model.getRtbAudienceEstimatedData
                      : undefined
                  }
                />
                <div
                  className={styles.importAudience}
                  onClick={this.props.model.showTAManagement}
                >
                  <FontAwesomeIcon icon={faFileImport} />
                  <span>
                    {i18n.t('editLimitation.buttons.importTargeting')}
                  </span>
                </div>
              </div>
              <div className={styles.shadowCoverBottom} />
            </>
          )}
        {this.props.renderFixOutdoorLimitationSection && (
          <fieldset className={styles.editLimitaionContainer}>
            <legend>
              <span>
                {i18n.t('limitation.title.fixOutdoorLimitationSection')}
              </span>
            </legend>
            <div className={styles.limitationSettingContainer}>
              <div className={styles.limitationSetting}>
                <div className={styles.limitationSet}>
                  {this.props.renderFixOutdoorLimitationSection()}
                </div>
              </div>
            </div>
          </fieldset>
        )}
        {this.props.renderWeatherSection && (
          <fieldset className={styles.editLimitaionContainer}>
            <legend>
              <span>{i18n.t('limitation.title.weatherSection')}</span>
              <span className={styles.weatherSectionHint}>
                {i18n.t('limitation.hint.weatherSection')}
              </span>
            </legend>
            <div className={styles.limitationSettingContainer}>
              <div className={styles.limitationSetting}>
                <div className={styles.limitationSet}>
                  {this.props.renderWeatherSection()}
                </div>
              </div>
            </div>
          </fieldset>
        )}
        {this.props.renderMapSection && (
          <fieldset className={styles.editLimitaionContainer}>
            <legend>
              <span>{i18n.t('limitation.title.mapSection')}</span>
            </legend>
            <div className={styles.limitationSettingContainer}>
              <div className={styles.limitationSetting}>
                <div className={styles.limitationSet}>
                  {this.props.renderMapSection(this.handleChange)}
                </div>
              </div>
            </div>
          </fieldset>
        )}
        {this.props.model.operationSet.need && (
          <fieldset className={styles.editLimitaionContainer}>
            <legend>
              <span>{i18n.t('limitation.title.you.need')}</span>
            </legend>
            {this.props.renderGeneralFields && (
              <div className={styles.limitationSettingContainer}>
                <div className={styles.limitationSetting}>
                  <div className={styles.limitationSet}>
                    <div className={styles.generalTitle}>
                      <span>{i18n.t('limitation.labels.general')}</span>
                    </div>
                    {this.props.renderGeneralFields(
                      this.props.model.limitationValue,
                      this.props.order,
                      this.handleChange
                    )}
                  </div>
                </div>
              </div>
            )}
            {this.props.model.operationSet.need.map((operationSet) => (
              <div
                key={operationSet}
                data-operate={operationSet}
                className={styles.limitationSettingContainer}
              >
                {renderLimitationSetting(operationSet)}
              </div>
            ))}
          </fieldset>
        )}
        {this.props.model.operationSet.notNeed && (
          <fieldset className={styles.editLimitaionContainer}>
            <legend>
              <span>{i18n.t('limitation.title.you.dont.need')}</span>
            </legend>
            {this.props.model.operationSet.notNeed.map((operationSet) => (
              <div
                key={operationSet}
                className={styles.limitationSettingContainer}
              >
                {renderLimitationSetting(operationSet)}
              </div>
            ))}
          </fieldset>
        )}
        {this.props.model.operationSet.other && (
          <PermissionChecker
            permissionAware={addOnEnabled(enablePMPDealKey, testModeKey)}
          >
            <fieldset className={styles.editLimitaionContainer}>
              <legend>
                <span>{i18n.t('limitation.title.other.need')}</span>
              </legend>
              <div className={styles.limitationSettingContainer}>
                <div className={styles.limitationSetting}>
                  <div className={styles.limitationSet}>
                    <PermissionChecker
                      permissionAware={addOnEnabled(testModeKey)}
                    >
                      <SwitchField
                        formGroupClassName={styles.testMode}
                        label={i18n.t('limitation.labels.testMode')}
                        name={'testMode'}
                        value={testMode ? testMode.value : 0}
                        onChange={this.handleTestModeChange}
                      />
                    </PermissionChecker>
                    <PermissionChecker
                      permissionAware={addOnEnabled(enablePMPDealKey).and(
                        addOnDisabled(testModeKey).or(
                          addOnEnabled(testModeKey).and(
                            inCondition(() =>
                              testMode ? testMode.value === 0 : true
                            )
                          )
                        )
                      )}
                    >
                      <Form.Group as={Row} controlId={'dealId'}>
                        <Form.Label>
                          {i18n.t('limitation.labels.dealId')}
                        </Form.Label>
                        <div style={{ flex: '1 1' }}>
                          <Tags
                            value={dealId.value}
                            onChange={this.handleChangeDealId}
                            operate={'dealId'}
                            showPlus={false}
                            placeholder={
                              dealId.value && dealId.value.length === 0
                                ? i18n.t('limitation.addDealId')
                                : ''
                            }
                            className={styles.tags}
                          />
                        </div>
                      </Form.Group>
                    </PermissionChecker>
                  </div>
                </div>
              </div>
            </fieldset>
          </PermissionChecker>
        )}
        {this.state.modalShown && (
          <ChangeOperateAlertDialog
            changeOperate={handleChangeOperateForAlert}
            dismiss={this.hideModal}
            type={type}
            newOperate={newOperate}
          />
        )}
      </div>
    );
  };

  render() {
    const { loading, showRequireIncludeLimitationInfo } =
      this.props.model.state;
    return (
      <div>
        {loading && <LoadingIndicator />}
        {showRequireIncludeLimitationInfo && (
          <Modal
            title={i18n.t('common.titles.error')}
            primaryButton={{
              title: i18n.t('common.buttons.confirm'),
              callback: this.props.model.hideRequireIncludeLimitationInfo
            }}
          >
            {i18n.t('editLimitation.errors.requireIncludeLimitation')}
          </Modal>
        )}
        {this.renderLimitationPage()}
      </div>
    );
  }
}
